/** =========================================================
 * Project types controller
 =========================================================*/

(function () {
  'use strict';

  angular
    .module('app.page-project-types')
    .controller('ProjectTypesController', ProjectTypesController);

  ProjectTypesController.$inject = ['$rootScope', '$scope', '$api', '$state', '$stateParams', '$translate'];

  function ProjectTypesController($rootScope, $scope, $api, $state, $stateParams, $translate) {
    var vm = this;

    vm.pageTitle = $state.current.title;
    vm.pageSubTitle = $state.current.subTitle;
    vm.init = false;

    if ($rootScope.appConfig) {
      activate();
    } else {
      var getAppConfig = $rootScope.$watch('appConfig', function (value) {
        if (value) {
          activate();
          getAppConfig();
        }
      });
    }

    // //////////////

    function activate() {
      vm.init = true;

      Raven.captureBreadcrumb({
        message: 'Page project types',
        data: {
          filters: $stateParams.filters
        }
      });

      vm.tableConfig = {
        model: 'project_type',
        getDataParams: {
          order: {
            id: 'desc'
          },
          count: ['projects']
        },
        filters: angular.copy($stateParams.filters),
        fields: [{
          title: 'Title',
          key: 'name',
          order: true
        }, {
          title: 'Slug',
          key: 'slug',
          order: true
        }],
        add: {
          template: 'app/views/dialogs/item-project-type.html'
        },
        edit: {
          template: 'app/views/dialogs/item-project-type.html',
          except: ['projects_count']
        },
        delete: {},
        linkButtons: [{
          title: 'Projects',
          icon: 'icon-folder-alt',
          class: 'btn-info',
          permission: $rootScope.helpers.hasPermissionTo('project view'),
          action: function (item) {
            try {
              $state.go('app.page-projects', {
                filters: [{
                  name: $translate.instant('Project type') + ': ' + item.name,
                  attr: 'where',
                  value: [
                    ['project_type_id', '=', item.id]
                  ]
                }]
              });
            } catch (error) {
              Raven.captureException(error);
            }
          },
          text: function (item) {
            try {
              return item.projects_count;
            } catch (error) {
              Raven.captureException(error);
            }

            return '';
          }
        }]
      };

      vm.tableConfig.getData = function () {
        try {
          return $rootScope.helpers.defaultGetData(vm.tableConfig);
        } catch (error) {
          Raven.captureException(error);
        }

        return $rootScope.helpers.emptyPromise();
      };

      vm.tableConfig.getData();

      $rootScope.helpers.initActiveTableConfig(vm.tableConfig);
    }
  }
})();
